// src/config/routeToPermission.js
// Maps route keys to Firestore permission names
const routeToPermission = {
  TpPortalMgtCourseCatalog: "Course Catalog",
  TpPortalMgtCourseShell: "Course Shell",
  TpCreditTypes: "Credit Types",
  TpCreditCapture: "Credit Capture",
  TpCreditCaptureStatus: "Credit Capture Status",
  TpCtag: "Ctag",
  TpCtagRetrievalForm: "Ctag Retrieval Form",
  TpDeliveryDetails: "Delivery Details",
  TpDivisions: "Divisions",
  TpElearnShellTerm: "Elearn Shell Term",
  TpElearnShellType: "Elearn Shell Type",
  TpFps: "FPS",
  TpFpsCourses: "FPS Courses",
  TpHeiPrograms: "HEI Programs",
  TpPathwayPrograms: "Pathway Programs",
  TpPartners: "Partners",
  TpResidenceStatusCodes: "Residence Status Codes",
  TpShellStatus: "Shell Status",
  TpCourseShellStatus: "Course Shell Status",
  TpSites: "Sites",
  TpSsnStatusCode: "SSN Status Code",
  TpStudents: "Students",
  TpStudentArchive: "Students",
  TpUsers: "Users",
  SchoolUsers: "School Users",
  ProgramDelivery: "Program Delivery",
  TpSearchStudents: "Search Students",
  TpSearchFormerStudents: "Search Former Students",
  TpSearchCoordinators: "Search Coordinators",
  TpSearchInstructors: "Search Instructors",
  TpSearchFps: "Search FPS",
  TpSearchCourses: "Search Courses",
  ShowcaseSubmissions: "Showcase Submissions",
  // New: Showcase Categories admin area
  TpShowcaseCategories: "Showcase Categories",
  // New: Showcase Locations admin area
  TpShowcaseLocations: "Showcase Locations",
  // New: Showcase Participation Status admin area
  TpShowcaseParticipationStatus: "Showcase Participation Status",
  // New: Showcase Submissions admin area
  TpShowcaseSubmissions: "Showcase Submissions",
  TpShowcaseToggles: "Showcase Submissions",
  // New: Showcase Email Template admin area
  TpShowEmailTemplate: "Showcase Email Template",
  // New: PTP Forms admin area
  TpPTPForms: "PTP Forms",
  PTPStatusNote: "PTP Status Note",
  // New: admin-only Data relationship visualizer
  TpData: "Data",
};

export default routeToPermission;
